export default __webpack_public_path__ + "static/media/invesco.c7b50faa.png";